// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		// loadProductFirst: true,
		styleScrollToTop: 'style2',
		defaultDisplay: bcSfFilterConfig.custom.layout,
	},
};

var bcSfFilterTemplate = {
	'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',

	// Grid Template
	'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
	'soldOutLabelGridHtml': ' <span class="product-price__sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
	'productGridItemHtml': document.getElementById('bc-sf-filter-product-card').innerHTML,
    
    // '<div class="o-product {{itemSoldOutClass}}">' +
	// '<a class="o-product__link" href="{{itemUrl}}">' +
	// '{{itemImages}}' +
	// '</a>' +
	// '<a class="iWishAddColl iwishcheck o-product__wish" href="#" data-variant="{{firstId}}" data-product="{{productId}}" data-pTitle="{{productTitle}}"></a>' +
	// '<div class="o-product__content">' +
	// '{{itemMediumVendor}}' +
	// '<div class="o-product__title">{{itemTitle}}</div>' +
	// '{{itemSpecs}}'+
	// '{{itemPrice}}' +
	// '</div>' +
	// '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
	// '</div>',

	// List Template
	'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
	'vendorMediumListHtml': '<div class="o-product__vendor">{{itemVendorLabel}}</div>',
	'saleLabelListHtml': '<div class="list-view-item__on-sale">' + bcSfFilterConfig.label.sale + '</div>',
	'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + bcSfFilterConfig.label.sold_out + '</div>',
	'productListItemHtml': '<li href="{{itemUrl}}" class="list-view-item">' +
	'<div class="product-card product-card--list">' +
	'<div class="list-view-item__link">' +
	'<div class="list-view-item__image-column">' +
	'<div class="list-view-item__image-wrapper">' +
	'<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
	'</div>' +
	'</div>' +
	'<div class="list-view-item__title-column">' +
	'<div class="list-view-item__title">{{itemTitle}}</div>' +
	'{{itemSaleLabel}}' +
	'{{itemMediumVendor}}' +
	'{{itemSoldOutLabel}}' +
	'</div>' +
	'{{itemSmallVendor}}' +
	'<div class="list-view-item__price-column">{{itemPrice}}</div>' +
	'</div>' +
	'</div>' +
	'</li>',

	// Pagination Template
	'previousActiveHtml': '<li class="nav-prev text-xs md:text-sm text-gray-800 font-medium leading-none"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
	'previousDisabledHtml': '<li class="nav-prev text-xs md:text-sm text-gray-400 font-medium leading-none"><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
	'nextActiveHtml': '<li class="nav-next text-xs md:text-sm text-gray-800 font-medium leading-none"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon__fallback-text">Next</span><svg aria-hidden="true" focusable="false" role="presentation" class="text-gray-800 icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg></a></li>',
	'nextDisabledHtml': '<li class="nav-next text-xs md:text-sm text-gray-800 font-medium leading-none"><div class="btn btn--secondary btn--narrow btn--disabled"><span class="icon__fallback-text">Next</span><svg aria-hidden="true" focusable="false" role="presentation" class="text-gray-400 icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg></div></li>',
	//'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',
  	'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}{{pageItems}}{{next}}</ul>',
	
	// SC AZ: pagaes templates
  	'pageItemHtml' : '<li class="nav-pages text-xs md:text-sm text-gray-800 font-medium leading-none"><a href="{{itemUrl}}" aria-label="Page {{itemTitle}}" title="Page {{itemTitle}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml' : '<li class="nav-pages text-xs md:text-sm text-red-600 font-medium leading-none"><span class="boost-pfs-filter-pagination-active" aria-label="Page {{itemTitle}}">{{itemTitle}}</span></li>',
  	'pageItemRemainHtml' : '<li class="nav-pages text-xs md:text-sm text-gray-400 font-medium leading-none"><span aria-label="Page {{itemTitle}}">{{itemTitle}}</span></li>',
  
	// Sorting Template
	'sortingHtml': '<select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

// Reset the tile counter before each Boost render so the first 4 get priority
(function () {
  var _origBefore = BCSfFilter.prototype.beforeGetFilterData || function(){};
  BCSfFilter.prototype.beforeGetFilterData = function (eventType) {
    window._bcTileCounter = 0;
    return _origBefore.call(this, eventType);
  };
})();

BCSfFilter.prototype.buildProductGridItem = function (data) {

	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

		// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add a specific class for grid item
	var itemGridWidthClass = '';
	var imageSize = '600x600';

	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2:
			itemGridWidthClass = 'medium-up--one-half';
			imageSize = '540x600';
			break;
		case 3:
			itemGridWidthClass = 'small--one-half medium-up--one-third';
			imageSize = '345x550';
			break;
		case 4:
			itemGridWidthClass = 'small--one-half medium-up--one-quarter';
			imageSize = '250x';
			break;
		case 5:
			itemGridWidthClass = 'small--one-half medium-up--one-fifth';
			imageSize = '195x';
			break;
	}
	itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, '');

	// Add soldOut class
	var itemSoldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

	// Add soldOut label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

	// Build Image style
	var imageStyle = buildImageStyle(data);
	itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

	// Add Images
    // var itemImagesHtml = '<div class="product-tile-bg-image" style="background-image: url(' + this.getFeaturedImage(images, '400x') + ');"></div>';
		
		if (typeof window._bcTileCounter !== 'number') window._bcTileCounter = 0;
		window._bcTileCounter++;
		var _priorityAttrs = (window._bcTileCounter <= 4)
			? 'loading="eager" fetchpriority="high"'
			: 'loading="lazy"';

		var itemImagesHtml =
			'<img src="' + this.getFeaturedImage(images, "400x") + '" alt="' + data.title +
			'" class="product-tile-image" ' + _priorityAttrs + '>';


	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    //Add Estimated retail price
    var itemErpHtml = buildErp(data);
    itemHtml = itemHtml.replace(/{{itemEstimatedRetailPrice}}/g, itemErpHtml);

	// Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    
    // Apply the replace logic only if there is no comma after '.000'
    if (!itemPriceHtml.includes('.000,')) {
        itemPriceHtml = itemPriceHtml.replace('.000', '0');
    }
    
    // Apply the formatted price to the item HTML
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);


    var itemCondition = buildCondition(data);
    var conditionClass = 'hidden';

    if (itemCondition) {
        itemHtml = itemHtml.replace(/{{conditionText}}/g, itemCondition);
        conditionClass = 'condition-' + itemCondition.toLowerCase().replace(/[^a-z0-9 -]/g, '') .replace(/\s+/g, '-').replace(/-+/g, '-'); 
    }

    itemHtml = itemHtml.replace(/{{conditionClass}}/g, conditionClass);

	// Add data json
	var self = this;
	var itemJson = {
		"id": data.id,
		"title": data.title,
		"handle": data.handle,
		"vendor": data.vendor,
		"variants": data.variants,
		"url": self.buildProductItemUrl(data),
		"options_with_values": data.options_with_values,
		"images": data.images,
		"available": data.available,
		"price_min": data.price_min,
		"price_max": data.price_max,
		"compare_at_price_min": data.compare_at_price_min,
		"compare_at_price_max": data.compare_at_price_max
	};
	itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));
	var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
	itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	itemHtml = itemHtml.replace(/{{firstId}}/g, firstVariant.id);

	itemHtml = itemHtml.replace(/{{productId}}/g, data.id);

	itemHtml = itemHtml.replace(/{{productTitle}}/g, data.title);

    
    const productData = metadataCorner.find(({title}) => title === data.title)  
    
    if(typeof productData !== "undefined") {
  		const { corner: { name, description}} = productData
  		itemHtml = itemHtml.replace(/{{CornerTreatment}}/g, `
  			<div class="corner_t">
  				<p>${name}</p>
  				<div class="ct_extras">
  					<p>${description}</p>
  				</div>
  			</div>
  		`);
  	}else{
  		itemHtml = itemHtml.replace(/{{CornerTreatment}}/g, "")
  	}

    var itemSpecs ='';
	var tags = data.tags;
	var collections = data.collections;
	var sizeAdded = false;
	var onhold = false;
	var finalSale = false;
	var preorder = false;
	var ship_date = '';
  
  // SC AZ: hide size for Necklaces
  	var hideSize = false;
  	for (var j = 0; j < collections.length; j++) {
    	if(collections[j]["handle"]==="necklaces" || collections[j]["handle"] == "handbags"){
      		hideSize = true;
    	}
    	if(collections[j]["handle"]==="coming-soon" ){
			preorder = true;
	  	}
  	}
  
    if (tags.length > 0) {
		for (var i = 0; i < tags.length; i++) {

			if(tags[i] == 'Hold') {
				onhold = true;
			}

			if(tags[i] == 'Final_Sale' || tags[i] == 'Final Sale') {
				finalSale = true;
			}

			if (tags[i].startsWith("Ship_Date_")) {
				ship_date = tags[i].replace('Ship_Date_', '');
			}			

			if (tags[i].startsWith("Size_") && !sizeAdded && !hideSize) {
              	sizeAdded = true;
              	//var val = tags[i].split('_').at(-1);
              var arr = tags[i].split('_');
              var val = arr[arr.length - 1];
				var text = bcSfFilterConfig.label.size;
				var textEnd='';
				for (var j = 0; j < collections.length; j++) {
					if(collections[j]["handle"]==="watches"){
						text = bcSfFilterConfig.label.case_width;
						textEnd = 'mm';
						break;
					}
				}
				//itemSpecs += '<div class="w-full text-xs md:text-sm text-gray-800 font-normal leading-relaxed"><span>'+text+':</span> <span>'+(tags[i].replace(/Size_Option_Cartier_Bracelet_Size_|Size_/, ""))+textEnd+'</span></div>';
              	itemSpecs += '<div class="w-full text-xs md:text-sm text-gray-800 font-normal leading-relaxed"><span>'+text+':</span> <span>'+val+textEnd+'</span></div>';
			}
		}
	}

	itemHtml = itemHtml.replace(/{{itemPreorderClass}}/g, preorder ? 'preorder' : '');
	itemHtml = itemHtml.replace(/{{itemOnHoldClass}}/g, onhold ? 'grid-view-item--sold-out product-card product-price--sold-out onhold' : '');
	itemHtml = itemHtml.replace(/{{itemShipDateProperty}}/g, ship_date == '' ? '' : '<input type="hidden" name="properties[Ship Date]" value="'+ship_date+'">');
	itemHtml = itemHtml.replace(/{{itemFinalSaleProperty}}/g, finalSale ? '<input type="hidden" name="properties[Final Sale]" value="Not eligible for return or exchange">' : '');
	itemHtml = itemHtml.replace(/{{itemNotifyMessage}}/g, onhold ? 'Notify If Product Becomes Available Again' : 'Notify When Similar Product Is Available');
	

	itemHtml = itemHtml.replace(/{{itemSpecs}}/g,itemSpecs);

	return itemHtml;
}

// Build Image style
function buildImageStyle(data) {
	var images = data.images_info;
	var imgId = 'ProductCardImage-' + data.id;
	var wrapperId = 'ProductCardImageWrapper-' + data.id;
	var imageStyle = '';
	if (images.length > 0) {
		var image = images[0];
		var width = bcSfFilterConfig.custom.max_height;
		var height = bcSfFilterConfig.custom.max_height;
		var aspect_ratio = image.width / image.height;
		var small_style = true;
		var container_aspect_ratio = width * 1.0 / height;

		if (image.aspect_ratio < 1.0) {
			var maximum_width = height * aspect_ratio;
			if (image.height <= height) {
				var maximum_height = image.height;
				maximum_width = image.width;
			} else {
				var maximum_height = height;
			}
		} else if (aspect_ratio < container_aspect_ratio) {
			var maximum_height = height / aspect_ratio;
			if (image.height <= height) {
				var maximum_height = image.height;
				var maximum_width = image.width;
			} else {
				var maximum_height = height;
				var maximum_width = height * aspect_ratio;
			}
		} else {
			var maximum_height = height / aspect_ratio;
			if (image.width <= width) {
				maximum_height = image.height;
				var maximum_width = image.width
			} else {
				var maximum_width = width;
				maximum_height = maximum_width / aspect_ratio;
			}
		}

		imageStyle += '<style>';
		if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
		imageStyle += '#' + imgId + ' {' +
			'max-width: ' + maximum_width + 'px;' +
			'max-height: ' + maximum_height + 'px;' +
			'}' +
			'#' + wrapperId + ' {' +
			'max-width: ' + maximum_width + 'px;' +
			'max-height: ' + maximum_height + 'px;' +
			'}';
		if (small_style) imageStyle += '}';

		if (small_style) {
			if (aspect_ratio < 1) {
				maximum_width = 750 * aspect_ratio;
			} else {
				if (image.width < 750) {
					maximum_width = image.width;
				} else {
					maximum_width = 750;
				}
			}
			imageStyle += '@media screen and (max-width: 749px) {'
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: 750px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'}';
			imageStyle += '}';
		}
		imageStyle += '</style>';
	}
	return imageStyle;
}

BCSfFilter.prototype.buildProductListItem = function (data) {

	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

		// Get Template
	var itemHtml = bcSfFilterTemplate.productListItemHtml;

	// Bump the same counter for grid+list share the first 4 slots on a page
	if (typeof window._bcTileCounter !== 'number') window._bcTileCounter = 0;
	window._bcTileCounter++;
	var _priorityAttrsList = (window._bcTileCounter <= 4)
		? 'loading="eager" fetchpriority="high"'
		: 'loading="lazy"';

	// Inject attributes into the list-view <img> BEFORE placeholder replacements
	itemHtml = itemHtml.replace(
		'<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">',
		'<img class="list-view-item__image" ' + _priorityAttrsList + ' src="{{itemThumbUrl}}" alt="{{itemTitle}}">'
	);

	// Add onSale label
	var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

	// Add soldOut label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

	// Add Thumbnail
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

	// Add Vendor
	var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorSmallListHtml : '';
	itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
	var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
	itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

	// Add Price
	var itemPriceHtml = buildPrice(data, onSale, priceVaries);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		position = position || 0;
		return this.indexOf(searchString, position) === position;
	};
}

function buildErp(data) {

    var erp = ""
        per = 0;

    for (var i = 0; i < data.tags.length; i++) {
        if (data.tags[i].startsWith("erp_")) {
            erp = parseFloat(data.tags[i].replace("erp_", "")) * 100;
        }
    }

	if (erp != '') {
		var og_price = data.price_min * 100;
		per = Math.round(100 - og_price / erp);

        return '<span class="retail-price text-9px md:text-xs text-gray-700 font-normal">' + bcSfFilterConfig.label.erp + ' ' + bcsffilter.formatMoney(erp, bcsffilter.moneyFormat) + '</span>';
	}
    

    return '';
}

function buildCondition(data) {

    var condition = null;

    for (var i = 0; i < data.tags.length; i++) {
        if (data.tags[i].startsWith("Pristine")) {
            var tagCondition = "Pristine";
            condition = tagCondition; 

            break;
        }
        // if (data.tags[i].startsWith("condition_")) {
        //     var tagCondition = data.tags[i].replace("condition_", "");

        //     if (['good', 'very good', 'great', 'excellent', 'new'].indexOf(tagCondition.toLowerCase()) != -1) {
        //         condition = tagCondition;
        //     } 

        //     break;
        // }
    }

    return condition;
}

function buildPrice(data, onSale, priceVaries) {
  var active_currency = Shopify.currency.active.toLowerCase();
  var og_price = data.price_min;
  var compare_price = data.compare_at_price_min;
  
  // Localized price check - keep this fix from your updated version
  if (data['price_min_' + active_currency]) {
    og_price = Math.round(parseFloat(data['price_min_' + active_currency]) * 100);
  }
  if (data['compare_at_price_min_' + active_currency]) {
    compare_price = Math.round(parseFloat(data['compare_at_price_min_' + active_currency]) * 100);
  }
  
  let priceHtml = '';
  // Main price
  priceHtml += '<span class="text-xs md:text-sm text-gray-800 font-medium leading-none"><span class="money" data-product-id="'+ data.id +'">' +
               bcsffilter.formatMoney(og_price, bcsffilter.moneyFormat, true) +
               '</span></span>';
  
  // Hidden compare price template - keep this exactly as is from both versions
  priceHtml += '<span class="money-template" data-product-id="'+ data.id +'" style="visibility: hidden;">' +
               '<script type="text/template">' +
               '{{#has_saved}}' +
               '<del class="text-xs md:text-sm font-medium leading-none line-through" style="color:#000;">' +
               '<span class="bold-pre-compare-price">{{original}}</span>' +
               '</del>' +
               '{{/has_saved}}' +
               '</script>' +
               '</span>';
  
  // On sale strikethrough - keep this from the updated version
  if (onSale && compare_price > og_price) {
    priceHtml += '<span class="text-xs md:text-sm font-medium leading-none line-through" style="color:#000;">' +
                 bcsffilter.formatMoney(compare_price, bcsffilter.moneyFormat, true) +
                 '</span>';
  }
  
  // Removed the ERP display section and material tag display section
  
  return priceHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		
      
        // SC AZ: pages
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}

      	paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      
      
      
      
		// Build page items
		//var currentPage = bcSfFilterConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		//paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);
		
      	
      
		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
	var itemHtml = '<span>View As </span>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
	jQ(this.selector.topDisplayType).html(itemHtml);

	// Active current display type
	jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
	jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
	if (this.queryParams.display == 'list') {
		jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
	} else if (this.queryParams.display == 'grid') {
		jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	/* start-initialize-bc-al */
	var self = this;
	var alEnable = true;
	if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
		alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
	}
	if (alEnable === true && typeof BCActionList !== 'undefined') {
		if (typeof bcActionList === 'undefined') {
			bcActionList = new BCActionList();
		} else {
			if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
				bcActionList.initFlag = false;
				bcActionList.alInit(bcSfFilterParams, bcAlParams);
			} else {
				bcActionList.alInit();
			}
		}
	}
	/* end-initialize-bc-al */
	var productSelector = jQ(this.selector.products);
	if (this.queryParams.display == 'list') {
		if (productSelector.children('.list-view-items').length == 0) {
			productSelector.children().wrapAll('ul class="list-view-items"/>');
		}
		productSelector.removeClass('grid grid--uniform grid--view-items');
	} else {
		if (productSelector.children('.list-view-items').length > 0) {
			productSelector.children('.list-view-items').children().unwrap();
		}
		productSelector.addClass('grid grid--uniform grid--view-items');
	}
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	var totalProduct = '';
	
    if (data.total_product == 1) {
		totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
	} else {
		totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
	}

	jQ('.bc-sf-filter-option-item[data-title="Fl/if"] .bc-sf-filter-option-value').text('FL-IF');
	jQ('.bc-sf-filter-selected-items .selected-type strong').each(function () {
		if (jQ(this).text() === 'Fl/if') {
			jQ(this).html('FL-IF');
		}
	});

	jQ('#bc-sf-filter-total-product').html(totalProduct);
	jQ("a[href='/apps/iwish']").click(function (e) {
		if (typeof(Storage) !== "undefined") {
			e.preventDefault();
			iWishPost('/apps/iwish', {iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid});
		}
	});

	jQ(".iWishAdd").click(function () {
		var iWishvId = jQ(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
		iwish_add(jQ(this), iWishvId);
		return false;
	});
  
    // sold out wishlist notify: handle click on new wishlist button
    jQ(".sold-out-wishlist-btn").click(function (e) {
      e.preventDefault();	

      var iWishvId = jQ(this).attr("data-variant");
      if(!jQ(this).hasClass('sold-out-wishlist-added')) {


		if(!ShopifyAnalytics.meta.page.customerId) {
			jQ('#login-modal').show();
			var elem = jQ(this).closest('.product-card').find('.iWishAddColl');
			elem.addClass('iwishAdded');
			elem.addClass('iwishAdding');
			return;
		}

        wishlistNotifyRequest(iWishvId, ShopifyAnalytics.meta.page.customerId);
        iwish_addCollection(jQ(this).closest('.product-card').find('.iWishAddColl'), iWishvId);
        jQ(this).addClass('sold-out-wishlist-added');
		wishlistNotifySuccessMessage(jQ(this));
      }
    });
  
	jQ(".iWishAddColl").click(function (e) {

		if(!ShopifyAnalytics.meta.page.customerId) {
			e.preventDefault();
			jQ('#login-modal').show();
			jQ(this).addClass('iwishAdded');
			jQ(this).addClass('iwishAdding');
			return;
		}

		var iWishvId = jQ(this).attr("data-variant");

        // sold out wishlist notify:  request to remote server to send the email notification
        if(
        	!jQ(this).hasClass('iwishAdded') &&
        	jQ(this).closest('.group').hasClass('product-price--sold-out')
        ) {
          var onhold = jQ(this).closest('.group').hasClass('onhold') || jQ(this).hasClass('onhold');
          wishlistNotifyRequest(iWishvId, ShopifyAnalytics.meta.page.customerId, onhold);
        }
      
		$('.iWishView').addClass('clicked');
		iwish_addCollection(jQ(this), iWishvId);


      
		return false;
	});
	
    if (typeof iwishCheckColl == 'function') {
        iwishCheckColl();
    }

    // sold out wishlist notify: mark the wishlist button as clicked
	if (jQ(".iwishcheck-btn").length > 0) {
		jQ(".iwishcheck-btn").each(function () {
			var iWishvId = jQ(this).attr("data-variant");
			var iWishpId = jQ(this).attr("data-product");
			if (isInWishlist(iWishpId, iWishvId)) {
                jQ(this).addClass('sold-out-wishlist-added');
			}
			jQ(this).removeClass("iwishcheck-btn");
		});
	}

  
	var iwish_added_txt_col = '';
	if (jQ(".iwishcheck").length > 0) {
		jQ(".iwishcheck").each(function () {
			var iWishvId = jQ(this).attr("data-variant");
			var iWishpId = jQ(this).attr("data-product");
			if (isInWishlist(iWishpId, iWishvId)) {
				jQ(this).addClass("iwishAdded").html(iwish_added_txt_col);
                //jQ(this).closest('.product-card').find('.sold-out-wishlist-btn').addClass('sold-out-wishlist-added');
			}
			jQ(this).removeClass("iwishcheck");
		});
	}
	var topCollectionBlocks = "";

	if (eventType != 'page') {
      if(typeof  themeCollections != "undefined") {
		for (var index = 0; index < themeCollections.length; index++) {
			var el = themeCollections[index];
			var html = "";

			html += '<div class="c-collection-block"><div class="c-collection-block__holder">';
			if (el.image != "") {
				html +=
					'<div class="c-collection-block__media">' +
					'<a class="c-collection-block__link" href="' + el.image_link + '"><img class="c-collection-block__img"' +
					'src="' +
					el.image +
					'"></a>' +
					"</div>";
			}
			html += '<div class="c-collection-block__body">';
			if (el.title != "") {
				html +=
					'<div class="c-collection-block__head">' +
					'<h2 class="c-collection-block__ttl">' + el.title + "</h2>" + "</div>";
			}
			if (el.description != "") {
				html +=
					'<div class="c-collection-block__copy">' +
					el.description +
					"</div>";
			}

			html += "</div></div></div>";

			topCollectionBlocks += html;

		}
      }
		jQ("#bc-sf-filter-products").append(topCollectionBlocks);
	}
}


// Build Default layout
function buildDefaultLink(a, b) {
	var c = window.location.href.split("?")[0];
	return c += "?" + a + "=" + b
}

BCSfFilter.prototype.buildDefaultElements = function (a) {
	if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) {
		var b = bcSfFilterConfig.general.collection_count, c = parseInt(this.queryParams.page),
			d = Math.ceil(b / this.queryParams.limit);
		if (1 == d) return jQ(this.selector.pagination).html(""), !1;
		if ("default" == this.getSettingValue("general.paginationType")) {
			var e = bcSfFilterTemplate.paginateHtml, f = "";
			f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f);
			var g = "";
			g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g);
			for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i);
			c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c);
			for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k);
			c + 3 < d && j.push("..."), c + 3 <= d && j.push(d);
			for (var l = "", m = h.concat(j), n = 0; n < m.length; n++) "..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n]));
			e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e)
		}
	}
	if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) {
		jQ(this.selector.topSorting).html("");
		var o = this.getSortingList();
		if (o) {
			var p = "";
			for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>";
			var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
			jQ(this.selector.topSorting).html(r);
			var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting;
			jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function (a) {
				window.location.href = buildDefaultLink("sort_by", jQ(this).val())
			})
		}
	}
};


// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
	
  // AZ: hide option products on the search page
  	var newData = [];
  	for (var k = 0; k < data.length; k++) {
      if(data[k].product_type != 'Options') {
        newData.push(data[k]);
      }      
    }
  
  	data = newData;
  
	for (var k = 0; k < data.length; k++) {
      
      //if(data[k].product_type == 'Options') {
      //  data.splice(k);
      //  continue;
      //}
      
		data[k]['images'] = data[k]['images_info'];
		if (data[k]['images'].length > 0) {
			data[k]['featured_image'] = data[k]['images'][0]
		} else {
			data[k]['featured_image'] = {
				src: bcSfFilterConfig.general.no_image_url,
				width: '',
				height: '',
				aspect_ratio: 0
			}
		}
		data[k]['url'] = '/products/' + data[k].handle;
		var optionsArr = [];
		for (var i = 0; i < data[k]['options_with_values'].length; i++) {
			optionsArr.push(data[k]['options_with_values'][i]['name'])
		}
		data[k]['options'] = optionsArr;
		data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
		data[k]['price'] = data[k]['price_min'];
		data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
		data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];
		var firstVariant = data[k]['variants'][0];
		if (getParam('variant') !== null && getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == getParam('variant')
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
		} else {
			for (var i = 0; i < data[k]['variants'].length; i++) {
				if (data[k]['variants'][i].available) {
					firstVariant = data[k]['variants'][i];
					break
				}
			}
		}
		data[k]['selected_or_first_available_variant'] = firstVariant;
		for (var i = 0; i < data[k]['variants'].length; i++) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]['variants'][i];
			var variantOptions = variant['merged_options'];
			if (Array.isArray(variantOptions)) {
				for (var j = 0; j < variantOptions.length; j++) {
					var temp = variantOptions[j].split(':');
					data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
					data[k]['variants'][i]['option_' + temp[0]] = temp[1];
					variantOptionArr.push(temp[1])
				}
				data[k]['variants'][i]['options'] = variantOptionArr
			}
			data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
			data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
		}
		data[k]['description'] = data[k]['content'] = data[k]['body_html']
	}
	return data
};

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */


  /* start-boost-custom */
  /* #boost-112502: customize search results */
BCSfFilter.prototype.getSearchTerm = function() {
    return getParam(this.searchTermKey).normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/-/g, ' ');
};

BCSfFilter.prototype.customizeSearchTerm = function(searchTerm) {
    return encodeURIParamValue(searchTerm.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/-/g, ' '));
};
  /* end-boost-custom */

BCSfFilter.prototype.buildProductItemUrl = function(a, b) {
	var c =
			"object" == typeof a && a.hasOwnProperty("handle")
				? a.handle
				: a,
		b = void 0 === b || b;
	if (b) {
		if (
			"/" == window.location.pathname ||
			this.isSearchPage() ||
			this.isVendorPage()
		)
			return Shopify.routes.root+"collections/all/products/" + c;
		if (this.isTagPage()) {
			var d = window.location.pathname.split("/");
			return d.length >= 4
				? Shopify.routes.root+"collections/"+ bcSfFilterConfig.general.collection_handle +"/products/" + c
				: Shopify.routes.root+"collections/all/products/" + c;
		}
		var d = window.location.pathname.split("/");
		return void 0 !== d[2]
			? Shopify.routes.root+"collections/"+ bcSfFilterConfig.general.collection_handle +"/products/" + c
			: window.location.pathname + "/products/" + c;
	}
	return "/products/" + c;
}